module.exports = __webpack_public_path__ + "static/covid19-romano-logo-8d61cb75e40c5e2f7dbc8586b460076d.png";